(() => {
  if (window.difineyJournalInitialized) return;
  window.difineyJournalInitialized = true;
  const initialize = (scope) => {
    scope.querySelectorAll('[data-journal]').forEach((journal) => {
      if (journal.dataset.journalReady) return;
      journal.dataset.journalReady = 'true';
      const body = journal.querySelector('[data-journal-body]');
      if (!body) return;
      const targets = new Map([[journal.id, journal]]);
      body.querySelectorAll('[id]').forEach((element) => targets.set(element.id, element));
      const headings = [...body.querySelectorAll('h2')];
      const generated = [{ id: journal.id, label: journal.dataset.introduction }];
      headings.forEach((heading, index) => {
        let target = heading.id ? heading : heading.closest('section[id]') || heading;
        if (!target.id) {
          let id = `${journal.id}-section-${index + 1}`;
          while (document.getElementById(id)) id += '-heading';
          target.id = id;
        }
        targets.set(target.id, target);
        generated.push({ id: target.id, label: heading.textContent.trim() });
      });
      journal.querySelectorAll('[data-journal-toc]').forEach((nav) => {
        const configured = [...nav.querySelectorAll('a')];
        const valid = configured.length > 0 && configured.every((a) => targets.has(a.getAttribute('href').slice(1)));
        if (valid) return;
        nav.replaceChildren(...generated.map((item) => {
          const link = document.createElement('a');
          link.setAttribute('href', `#${item.id}`);
          link.textContent = item.label;
          return link;
        }));
      });
      journal.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !journal.contains(link)) return;
        const target = targets.get(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        const details = link.closest('.dj-mobile-toc');
        if (details) details.open = false;
        const offset = Number.parseFloat(getComputedStyle(journal).getPropertyValue('--journal-sticky-offset')) || 0;
        const top = window.scrollY + target.getBoundingClientRect().top - offset - 24;
        window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        history.replaceState(null, '', link.getAttribute('href'));
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
